import { h, Component, ComponentChildren } from 'preact'
import { common } from '../common'
import globals from '../../utils/globals'

interface State {
  displayOriginal: boolean
}

interface Props {
  children?: ComponentChildren,
  type: 'img' | 'background',
  style?: Object,
  src: string,
  title?: string,
  alt?: string,
  classNames?: string,
}

interface LazyComponentType extends Element {
  src: string,
  style: {
    backgroundImage: string
  },
  dataset: {
    src: string
  }
}

class LazyLoaderComponent extends Component<Props, State> {
  ref: null | HTMLElement = null
  constructor (props: Props) {
    super(props)
    this.state = {
      displayOriginal: false
    }
  }

  componentDidMount () {
    if (!common.isModuleActive('lazyLoading') || globals('application') === 'control' || !document.body.classList.contains('twig_site-index') || this.ref === null) {
      this.setState({ displayOriginal: true })
      return
    }

    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      let lazyObserver = new IntersectionObserver((entries) => { // eslint-disable-line no-undef
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // @ts-ignore
            let lazyComponent: LazyComponentType = entry.target
            if (this.props.type === 'img') {
              lazyComponent.src = lazyComponent.dataset.src
            } else {
              lazyComponent.style.backgroundImage = `url(${lazyComponent.dataset.src})`
            }
            lazyComponent.classList.remove('lazy')
            lazyObserver.unobserve(lazyComponent)
          }
        })
      })

      lazyObserver.observe(this.ref)
    } else {
      this.setState({ displayOriginal: true })
    }
  }

  render ({ children, type, style = {}, src, title = '', alt = '', classNames = '' }: Props, { displayOriginal }: State) {
    if (displayOriginal) {
      if (type === 'img') {
        return <img className={classNames} src={src} style={{ ...style }} title={title} alt={alt || title} />
      } else if (type === 'background') {
        return <div role='img' aria-label={alt || title} className={classNames} style={{ ...style, 'background-image': `url(${src})` }}>{ children }</div>
      }
    }
    if (type === 'img') {
      return <img ref={ref => { this.ref = ref }} className={`lazy ${classNames}`} data-src={src} style={{ ...style }} title={title} alt={alt || title} />
    }
    return <div role='img' aria-label={alt || title} ref={ref => { this.ref = ref }} className={`lazy ${classNames}`} data-src={src}> { children } </div>
  }
}

const LazyLoader = (props: Props) => <LazyLoaderComponent {...props} />

export default LazyLoader
